const noopUnsubscribe = () => {};
const WEB_SETTINGS_KEY = "lenscore:control-settings";
const webDefaults = {
  apiEnabled: true,
  apiPort: 4789,
  cameraMode: "preview",
  cameraDeviceId: "",
  cameraLabel: "",
  cameraAutoStart: true,
  sourceWidth: 1280,
  sourceHeight: 720,
  sourceFps: 60,
  outputMode: "fixed",
  outputWidth: 1280,
  outputHeight: 720,
  outputFps: 60,
  rendererDeviceClass: "high-end",
  virtualCameraEnabled: false,
  virtualCameraName: "LensCore Virtual Camera",
  virtualCameraWidth: 1280,
  virtualCameraHeight: 720,
  virtualCameraFps: 60,
  virtualCameraTelemetry: false,
  settingsCollapsed: false,
  remoteControlEnabled: true,
  remoteControlDeviceId: "",
  remoteControlRoom: "default",
};

function readWebSettings() {
  try {
    const settings = { ...webDefaults, ...JSON.parse(localStorage.getItem(WEB_SETTINGS_KEY) || "{}") };
    if (!settings.remoteControlDeviceId) {
      settings.remoteControlDeviceId = crypto.randomUUID();
      localStorage.setItem(WEB_SETTINGS_KEY, JSON.stringify(settings));
    }
    return settings;
  } catch {
    return { ...webDefaults };
  }
}

function updateWebSettings(patch) {
  const next = { ...readWebSettings(), ...(patch || {}) };
  try { localStorage.setItem(WEB_SETTINGS_KEY, JSON.stringify(next)); } catch { /* storage may be disabled */ }
  return next;
}

const fallbackHost = {
  ready() {},
  reportState() {},
  reportCameras() {},
  onCommand() { return noopUnsubscribe; },
  commandResult() {},
  onSettingsChanged() { return noopUnsubscribe; },
  onMenuAction() { return noopUnsubscribe; },
  async getSettings() { return readWebSettings(); },
  async getApiCalls() { return []; },
  writeLog() {},
  async getSessionLogInfo() { return { available: false, path: "", maxBytes: 0 }; },
  async openSessionLog() { throw new Error("Session logs are only available in the desktop app."); },
  async copyText(text) {
    const value = String(text || "");
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(value);
      return { ok: true };
    }
    const field = document.createElement("textarea");
    field.value = value;
    field.style.position = "fixed";
    field.style.opacity = "0";
    document.body.appendChild(field);
    field.select();
    const copied = document.execCommand("copy");
    field.remove();
    if (!copied) throw new Error("Clipboard access is unavailable.");
    return { ok: true };
  },
  async copyApiToken() {
    throw new Error("The local API credential is only available in the desktop app.");
  },
  async rotateApiToken() {
    throw new Error("The local API credential is only available in the desktop app.");
  },
  async updateSettings(patch) { return updateWebSettings(patch); },
  async selectLensFile() { return null; },
  async fetchLensUrl(payload) {
    const lensId = String(payload?.lensId || "").trim();
    const source = String(payload?.url || (lensId
      ? `https://search-lens.byteo.app/api/lens-search/lens/${encodeURIComponent(lensId)}/download`
      : "")).trim();
    if (!source) throw new Error("Lens URL is required.");
    const proxy = new URL("/_proxy", window.location.origin);
    proxy.searchParams.set("url", source);
    const response = await fetch(proxy, { credentials: "include" });
    if (!response.ok) throw new Error(`Lens download failed (${response.status}).`);
    const bytes = await response.arrayBuffer();
    return {
      lensId: String(payload?.lensId || ""),
      fileName: String(payload?.lensId || "lens"),
      source,
      bytes,
      buffer: bytes,
    };
  },
  async getCachedLenses() { return { lenses: [], manifestPath: "" }; },
  async cachedLensFile() { throw new Error("lensAppHost preload missing"); },
  async virtualCameraCommand() { return { ok: false, error: "preload missing" }; },
  async runtimeStatus() {
    return { available: false, connected: false, error: "preload missing" };
  },
  async runtimeCommand() { throw new Error("lensAppHost preload missing"); },
  onRuntimeStatus() { return noopUnsubscribe; },
};

export const host = typeof window !== "undefined" && window.lensAppHost
  ? window.lensAppHost
  : fallbackHost;
